import React, { Component } from 'react'
import { formatDate } from '../../../helpers.js'

class AdminPost extends Component {
  renderBodyText = (post) => {
    return {__html: post.bodytext}
  }

  render() {
    return (
      <article className="w-100 pa4 mb3 bg-white card">
        <div className="head pathway w-100 flex flex-row justify-between items-end bb2">
          <div className="title f3 f2-m f1-l">
            {this.props.post.headline}
          </div>
          <div className="f4">
						{formatDate(this.props.post.timestamp)}
          </div>
        </div>
        <hr className="w-100 mt1 mb3"/>
        <div className="droid f5 lh-copy">
          <div dangerouslySetInnerHTML={this.renderBodyText(this.props.post)} />
        </div>
				<div className="dib card pointer bg-animate dim bg-very-red pa2 fr">
					<i className="fa fa-trash f2 near-white" 
						aria-hidden="true" 
						onClick={() => {this.props.deletePost(this.props.post)}} 
					/>
				</div>
      </article>
    )
  }
}

export default AdminPost


// WEBPACK FOOTER //
// ./src/components/admin/multi/AdminPost.js